// src/belediye/components/utils/TrDateTime.js
import React, { useMemo } from "react";
import { formatDateTr, formatDateTimeTr } from "./dateTime";

/**
 *   NEW: Smart formatter (named export)
 * Sayfalar şunu import edebilsin diye:
 *   import { formatTrDateTimeSmart } from "../../components/utils/TrDateTime";
 */
export const formatTrDateTimeSmart = (
  value,
  {
    mode = "datetime",
    timeZone = "Europe/Istanbul",
    withSeconds = false,
    separator = " • ",
  } = {}
) => {
  if (mode === "date") return formatDateTr(value, { timeZone });
  return formatDateTimeTr(value, { timeZone, withSeconds, separator });
};

/**
 * Ortak tarih/saat render bileşeni
 *
 * Props:
 * - value: date string | Date | number
 * - mode: "date" | "datetime" (default "datetime")
 * - timeZone: default "Europe/Istanbul"
 * - withSeconds: default false
 * - separator: default " • "
 * - className
 * - title (tooltip)
 */
export default function TrDateTime({
  value,
  mode = "datetime",
  timeZone = "Europe/Istanbul",
  withSeconds = false,
  separator = " • ",
  className = "",
  title,
}) {
  const text = useMemo(() => {
    if (mode === "date") return formatDateTr(value, { timeZone });
    return formatDateTimeTr(value, { timeZone, withSeconds, separator });
  }, [value, mode, timeZone, withSeconds, separator]);

  return (
    <span className={className} title={title}>
      {text}
    </span>
  );
}